'use client'

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"
import LoadingFullscreen from "@/src/components/loadings/loading-fullscreen/loading-fullscreen"
import { useCustomer } from "@/src/context/customer/customer-context"
import { useMerchant } from "@/src/context/merchant/merchant-context"
import { Overlay } from "../components/helpers/overlays/overlay"
import { useShoppingCart } from "../context/shopping-cart/shopping-cart-context"

export default function RootTemplate({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()
    const { customerLoginStatus } = useCustomer()
    const { addFee, shoppingCart } = useShoppingCart()
    const { setLocalMode, merchantSummary } = useMerchant()
    const searchParams = useSearchParams()

    const [isMounted, setIsMounted] = useState<boolean>(false)

    const renderLoadingScreen = () => {
        if (merchantSummary?.onPause)
            return <></>

        if (!isMounted || customerLoginStatus === 'verifying')
            return <LoadingFullscreen opacity={false} showMerchantLogo />

        return <></>
    }

    useEffect(() => {
        if (!pathname.startsWith('/carrinho') && shoppingCart?.fee)
            addFee(0)
    }, [pathname])

    useEffect(() => {
        const routes = ['/', '/pedido']

        if (merchantSummary && routes.some(r => !pathname.includes(r))) {
            const lastSegment = pathname.split("/").filter(Boolean).pop();

            if (lastSegment) {
                const routeName = (lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).replaceAll('-', ' '))

                if (routeName && !isNaN(Number(routeName)))
                    return

                if (routeName)
                    document.title = `${merchantSummary.name} - ${routeName}`
            }
        }
    }, [pathname, merchantSummary])

    useEffect(() => {
        const localmode = searchParams.get('localmode') ?? ''

        if (localmode.toLowerCase() === 'on')
            setLocalMode(true)
        else
            setLocalMode(false)

        Overlay.startWatch()
        setIsMounted(true)

        if (typeof window !== 'undefined')
            window.scrollTo({ top: 0 })
    }, [])

    return (
        <>
            {renderLoadingScreen()}
            {children}
        </>
    )
}
